// App Auth Actions
import ACTIONS from "@/Constants/actionsList";

// Helpers
import { getDepartmentalPosition, supportedSystemPositions } from "@/Common/helpers/Positions";

const POSITIONS = supportedSystemPositions();

// API's
// Finance Managers Queries
import {
	getFinancePayPlan,
	getFinancePayPlans,
	getFinancePayPlanMatches,
	getFinancePayPlansSidebarTree,
} from "@/PayPlans/api/finance/managers/queries";

// Finance Managers Mutations
import {
	createFinancePayPlan,
	saveNewFinancePayPlan,
	updateFinancePayPlan,
	deleteFinancePayPlan,
	cloneFinancePayPlan,
	updateFinanceAvailablePayPlan,
} from "@/PayPlans/api/finance/managers/mutations";

// Finance Managers Subscriptions
import {
	onCloneFinanceManagerPayPlan,
	onCreateFinanceManagerPayPlan,
	onDeleteFinanceManagerPayPlan,
	onUpdateFinanceManagerPayPlan,
	onUpdateFinanceAvailablePayPlan,
} from "@/PayPlans/api/finance/managers/subscriptions";

const getQueries = (position) => {
	// API Queries
	const queries = {
		getPayPlan: async () => {},
		getPayPlans: async () => {},
		getPayPlansSidebarTree: async () => {},
		getMatches: async () => {},
	};

	switch (position) {
		case POSITIONS.FINANCE.FINANCE_DIRECTOR:
		case POSITIONS.FINANCE.FINANCE_MANAGER:
			return {
				getPayPlan: getFinancePayPlan,
				getPayPlans: getFinancePayPlans,
				getMatches: getFinancePayPlanMatches,
				getPayPlansSidebarTree: getFinancePayPlansSidebarTree,
			};
		default:
			break;
	}

	return queries;
};

const getMutations = (position) => {
	// API Mutations
	const mutations = {
		addPayPlan: async () => {},
		saveNewPayPlan: async () => {},
		updatePayPlan: async () => {},
		deletePayPlan: async () => {},
		clonePayPlan: async () => {},
		updateAvailablePayPlan: async () => {},
	};

	switch (position) {
		case POSITIONS.FINANCE.FINANCE_DIRECTOR:
		case POSITIONS.FINANCE.FINANCE_MANAGER:
			mutations.addPayPlan = createFinancePayPlan;
			mutations.saveNewPayPlan = saveNewFinancePayPlan;
			mutations.updatePayPlan = updateFinancePayPlan;
			mutations.deletePayPlan = deleteFinancePayPlan;
			mutations.clonePayPlan = cloneFinancePayPlan;
			mutations.updateAvailablePayPlan = updateFinanceAvailablePayPlan;
			break;
		default:
			break;
	}

	return mutations;
};

const getSubscriptions = (position) => {
	// API Subscriptions
	const subscriptions = new Map([
		["onClonePayPlan", { query: "", getter: "" }],
		["onCreatePayPlan", { query: "", getter: "" }],
		["onDeletePayPlan", { query: "", getter: "" }],
		["onUpdatePayPlan", { query: "", getter: "" }],
		["onUpdateAnyPayPlan", { query: "", getter: "" }],
		["onUpdateAvailablePayPlan", { query: "", getter: "" }],
	]);

	switch (position) {
		case POSITIONS.FINANCE.FINANCE_DIRECTOR:
		case POSITIONS.FINANCE.FINANCE_MANAGER:
			subscriptions.set("onClonePayPlan", { query: onCloneFinanceManagerPayPlan, getter: "onCloneFinancePayPlan" });
			subscriptions.set("onCreatePayPlan", { query: onCreateFinanceManagerPayPlan, getter: "onCreateFinancePayPlan" });
			subscriptions.set("onDeletePayPlan", { query: onDeleteFinanceManagerPayPlan, getter: "onDeleteFinancePayPlan" });
			subscriptions.set("onUpdatePayPlan", { query: onUpdateFinanceManagerPayPlan, getter: "onUpdateFinancePayPlan" });
			subscriptions.set("onUpdateAvailablePayPlan", {
				query: onUpdateFinanceAvailablePayPlan,
				getter: "onUpdateFinanceAvailablePayPlan",
			});
			break;
		default:
			break;
	}

	return subscriptions;
};

const getServices = (position) => {
	const departmental = getDepartmentalPosition(position);
	const queries = getQueries(departmental);
	const mutations = getMutations(departmental);
	const subscriptions = getSubscriptions(departmental);

	return {
		queries,
		mutations,
		subscriptions,
	};
};

const EDIT_ACTIONS = new Map([
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, ACTIONS.EDIT_FINANCE_DIRECTOR_PAY_PLANS],
	[POSITIONS.FINANCE.FINANCE_MANAGER, ACTIONS.EDIT_FINANCE_MANAGER_PAY_PLANS],
]);

const getEditActions = (position) => {
	return {
		editable: EDIT_ACTIONS.get(position) || "",
	};
};

const getFinanceServices = (position) => {
	// Auth actions
	const actions = getEditActions(position);

	// API Queries
	const { queries, mutations, subscriptions } = getServices(position);

	const getPayPlan = async (locationId, id, extraPosition) => getFinancePayPlan(locationId, id, extraPosition || position);
	const getMatches = async (locationId, id, extraPosition) => getFinancePayPlanMatches(locationId, id, extraPosition || position);

	return {
		queries: {
			...queries,
			getPayPlan,
			getMatches,
		},
		actions,
		mutations,
		subscriptions,
	};
};

export { getFinanceServices };
